import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { PrimitiveButton } from '../../button/primitive-button/PrimitiveButton.mjs';
import { useDatePickerContext } from '../context/datePickerContext.mjs';

const CONTROLLER_NAME = "Clear";
const DatePickerClear = forwardRef(({ __scopeDatePicker, ...props }, ref) => {
  const { clearSelected } = useDatePickerContext(
    CONTROLLER_NAME,
    __scopeDatePicker
  );
  return /* @__PURE__ */ jsx(
    PrimitiveButton,
    {
      ...props,
      ref,
      onClick: (e) => {
        props.onClick?.(e);
        if (!e.isDefaultPrevented()) {
          clearSelected();
        }
      }
    }
  );
});

export { DatePickerClear as default };
//# sourceMappingURL=Clear.mjs.map
